export const font = {
  heading: {
    name: 'Plus Jakarta Sans',
    cssValue: '"Plus Jakarta Sans", sans-serif',
  },
  body: {
    name: 'DM Sans',
    cssValue: '"DM Sans", ui-sans-serif, system-ui',
  },
  mono: {
    name: 'DM Mono',
    cssValue: '"DM Mono", ui-monospace, monospace',
  },
};

export const googleFontsUrl =
  'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&family=Plus+Jakarta+Sans:wght@800&family=DM+Mono:wght@400&display=swap';

type Font = {
  name: string;
  families: string[];
  cssValue: string;
  google: boolean;
};

export const conditionalFonts: Font[] = [
  {
    name: 'impact', // Impact is a standard font. However, it's not available on Android devices. Therefore we add Anton as a fallback.
    families: ['Anton'],
    cssValue: 'Impact, Anton, sans-serif',
    google: true,
  },
  {
    name: 'pangolin',
    families: ['Pangolin'],
    cssValue: '"Pangolin", cursive',
    google: true,
  },
  {
    name: 'andada',
    families: ['Andada Pro'],
    cssValue: '"Andada Pro", serif',
    google: true,
  },
  {
    name: 'dosis',
    families: ['Dosis:wght@400;700'],
    cssValue: '"Dosis", "Lucida Console", sans-serif',
    google: true,
  },
  {
    name: 'roboto',
    families: ['Roboto:wght@400;700'],
    cssValue: '"Roboto", sans-serif',
    google: true,
  },
  {
    name: 'varelaround',
    families: ['Varela Round'],
    cssValue: '"Varela Round", Arial, sans-serif',
    google: true,
  },
  {
    name: 'kreon',
    families: ['Kreon'],
    cssValue: '"Kreon", Arial, sans-serif',
    google: true,
  },
];

export const notoIconsFont: Font = {
  name: 'noto-color-emoji',
  families: ['Noto Color Emoji'],
  cssValue: '"Noto Color Emoji", sans-serif',
  google: true,
};

export function fontFamiliesToGoogleFontsUrl(fonts: Font[]) {
  return `https://fonts.googleapis.com/css2?${fonts
    .flatMap((c) =>
      c.families.map((family) => {
        // Match 'FontName:wght@400;700' or 'FontName:ital,wght@0,400;1,700'
        const weightMatch = family.match(/^([\w+]+):([\w,@;]+)$/);
        if (weightMatch) {
          const fontName = weightMatch[1].replace(/ /g, '+');
          const params = weightMatch[2];
          return `family=${fontName}:${params}`;
        }
        return `family=${family.replace(/ /g, '+')}`;
      })
    )
    .join('&')}&display=swap`;
}

export function editorExtraGoogleFontsUrl() {
  return fontFamiliesToGoogleFontsUrl(conditionalFonts);
}
